"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleRankMap = exports.SupportTypeMap = exports.EngagementMap = exports.FormationMap = exports.DetectionMap = exports.AirControlMap = exports.NightAttackTypeMap = exports.DayAttackTypeMap = exports.Rank = exports.Result = exports.Detection = exports.Formation = exports.Engagement = exports.EngagementInfo = exports.AirControl = exports.AerialInfo = exports.ShipOwner = exports.Ship = exports.HitType = exports.MultiTargetAttackOrder = exports.MultiTargetAttackType = exports.AttackType = exports.Attack = exports.StageType = exports.Stage = void 0;
function toParam4(v) {
    return [v?.[0] ?? 0, v?.[1] ?? 0, v?.[2] ?? 0, v?.[3] ?? 0];
}
function param4(a = 0, b = 0, c = 0, d = 0) {
    return [a, b, c, d];
}
function isRecord(v) {
    return typeof v === "object" && v !== null;
}
function isRawFleetShip(ship) {
    if (!isRecord(ship))
        return false;
    const s = ship;
    return (typeof s.api_ship_id === "number" &&
        typeof s.api_maxhp === "number" &&
        typeof s.api_nowhp === "number" &&
        Array.isArray(s.poi_slot));
}
function isBattlePacket(packet) {
    return (isRecord(packet) &&
        "poi_path" in packet &&
        typeof packet.poi_path === "string");
}
function getShipDb() {
    return window.$ships ?? {};
}
function getSlotItemDb() {
    return window.$slotitems ?? {};
}
class Stage {
    constructor(opts) {
        this.type = opts.type; // StageType
        this.subtype = opts.subtype;
        this.attacks = opts.attacks; // [Attack, ...]
        this.aerial = opts.aerial; // AerialInfo
        this.engagement = opts.engagement; // EngagementInfo
        this.kouku = opts.kouku; // Raw API data `api_kouku` (Deprecated)
    }
}
exports.Stage = Stage;
exports.StageType = {
    // Primary Type
    Aerial: "Aerial", // Aerial Combat
    Torpedo: "Torpedo", // Torpedo Salvo
    Shelling: "Shelling", // Shelling
    Support: "Support", // Support Fleet (Expedition)
    LandBase: "LandBase", // Land Base Aerial Support
    Engagement: "Engagement", // [SP] Engagement Information
    // Sub Type
    Main: "Main", // Shelling, main fleet
    Escort: "Escort", // Shelling, escort fleet
    Night: "Night", // Shelling, night combat
    Opening: "Opening", // Torpedo,  opening torpedo salvo
    // Shelling, opening anti-sub
    Assault: "Assault", // Aerial & LandBase, Jet Air Assault
};
class Attack {
    constructor(opts) {
        this.type = opts.type; // AttackType
        this.fromShip = opts.fromShip; // Ship
        this.toShip = opts.toShip; // Ship
        this.damage = opts.damage; // [int, ...]
        this.hit = opts.hit; // [HitType, ...]
        this.fromHP = opts.fromHP; // HP before attack.
        this.toHP = opts.toHP; // HP after attack.
        this.useItem = opts.useItem; // int, $slotitem[] OR null
    }
}
exports.Attack = Attack;
exports.AttackType = {
    Normal: "Normal", // 通常攻撃
    Laser: "Laser", // レーザー攻撃
    Double: "Double", // 連撃
    Nelson_Touch: "Nelson", // ネルソンタッチ
    Nagato_Punch: "Nagato", // 一斉射かッ…胸が熱いな！
    Mutsu_Splash: "Mutsu", // 長門、いい？ いくわよ！ 主砲一斉射ッ！
    Colorado_Fire: "Colorado", // 	Colorado戦隊、全力斉射！各個目標に砲撃開始！一気に殲滅する、Fire!!
    Kongo_Class_Kaini_C_Charge: "Kongo_Class_Kaini_C",
    Yamato_Attack_Double: "Yamato_Double",
    Yamato_Attack_Triple: "Yamato_Triple",
    Baguette_Charge: "Baguette_Charge",
    QE_Touch: "QE_Touch",
    Submarine_Special_Attack_2_3: "Submarine_Special_Attack_2_3",
    Submarine_Special_Attack_3_4: "Submarine_Special_Attack_3_4",
    Submarine_Special_Attack_2_4: "Submarine_Special_Attack_2_4",
    Zuiun_Night_Attack: "Zuiyun_Night_Attack",
    Type_4_LC_Special_Attack: "Type_4_LC_Special_Attack",
    Carrier_CI: "CVCI", // 空母カットイン
    Primary_Secondary_CI: "PSCI", // カットイン(主砲/副砲)
    Primary_Radar_CI: "PRCI", // カットイン(主砲/電探)
    Primary_AP_CI: "PACI", // カットイン(主砲/徹甲)
    Primary_Primary_CI: "PrCI", // カットイン(主砲/主砲)
    Primary_Torpedo_CI: "PTCI", // カットイン(主砲/魚雷)
    Torpedo_Torpedo_CI: "TTCI", // カットイン(魚雷/魚雷)
};
exports.MultiTargetAttackType = new Set([
    exports.AttackType.Nelson_Touch,
    exports.AttackType.Nagato_Punch,
    exports.AttackType.Mutsu_Splash,
    exports.AttackType.Colorado_Fire,
    exports.AttackType.Kongo_Class_Kaini_C_Charge,
    exports.AttackType.Yamato_Attack_Double,
    exports.AttackType.Yamato_Attack_Triple,
    exports.AttackType.Baguette_Charge,
    exports.AttackType.QE_Touch,
    exports.AttackType.Submarine_Special_Attack_2_3,
    exports.AttackType.Submarine_Special_Attack_3_4,
    exports.AttackType.Submarine_Special_Attack_2_4,
    exports.AttackType.Zuiun_Night_Attack,
    exports.AttackType.Laser,
    exports.AttackType.Type_4_LC_Special_Attack,
]);
exports.MultiTargetAttackOrder = {
    [exports.AttackType.Nelson_Touch]: [0, 2, 4],
    [exports.AttackType.Nagato_Punch]: [0, 0, 1],
    [exports.AttackType.Mutsu_Splash]: [0, 0, 1],
    [exports.AttackType.Colorado_Fire]: [0, 1, 2],
    [exports.AttackType.Kongo_Class_Kaini_C_Charge]: [0, 1],
    [exports.AttackType.Yamato_Attack_Double]: [0, 0, 1],
    [exports.AttackType.Yamato_Attack_Triple]: [0, 1, 2],
    [exports.AttackType.Baguette_Charge]: [0, 0, 1],
    [exports.AttackType.QE_Touch]: [0, 0, 1],
    [exports.AttackType.Submarine_Special_Attack_2_3]: [1, 1, 2, 2],
    [exports.AttackType.Submarine_Special_Attack_3_4]: [2, 2, 3, 3],
    [exports.AttackType.Submarine_Special_Attack_2_4]: [1, 1, 3, 3],
    [exports.AttackType.Zuiun_Night_Attack]: [0, 0],
    [exports.AttackType.Laser]: [0, 0, 0],
    [exports.AttackType.Type_4_LC_Special_Attack]: [0, 0, 0, 0, 0, 0],
};
exports.HitType = {
    Miss: 0,
    Hit: 1,
    Critical: 2,
};
class Ship {
    constructor(opts) {
        this.id = opts.id; // int, $ships
        this.owner = opts.owner; // ShipOwner
        this.pos = opts.pos; // int, Position in fleet
        this.maxHP = opts.maxHP;
        this.nowHP = opts.nowHP;
        this.initHP = opts.nowHP;
        this.hpUnknown = opts.hpUnknown || false;
        this.lostHP = opts.lostHP || 0;
        this.damage = opts.damage || 0; // Damage from this to others
        this.items = opts.items;
        this.useItem = opts.useItem || null;
        this.baseParam = opts.baseParam;
        this.finalParam = opts.finalParam;
        // parameter = [FRP, TORP, AA, AMOR]
        // if !usePoiAPI, baseParam and finalParam are undefined
        this.raw = opts.raw;
    }
}
exports.Ship = Ship;
exports.ShipOwner = {
    Ours: "Ours",
    Enemy: "Enemy",
    Friend: "Friend",
};
class AerialInfo {
    constructor(opts = {}) {
        this.fPlaneInit = opts.fPlaneInit; // Init plane count of entire aerial combat (Ours)
        this.fPlaneNow = opts.fPlaneNow; // Now  plane count of entire aerial combat (Ours)
        this.ePlaneInit = opts.ePlaneInit; // ^^ (Enemy)
        this.ePlaneNow = opts.ePlaneNow; // ^^ (Enemy)
        // Stage 1
        this.control = opts.control; // AirControl
        this.fContact = opts.fContact; // api_kouku.api_stage1.api_touch_plane[0]
        this.eContact = opts.eContact; // api_kouku.api_stage1.api_touch_plane[1]
        this.fPlaneInit1 = opts.fPlaneInit1; // Init plane count of stage 1
        this.fPlaneNow1 = opts.fPlaneNow1; // Now  plane count of stage 1
        this.ePlaneInit1 = opts.ePlaneInit1; // ^^
        this.ePlaneNow1 = opts.ePlaneNow1; // ^^
        // Stage 2
        this.aaciKind = opts.aaciKind; // api_kouku.api_stage2.api_air_fire.api_kind
        this.aaciShip = opts.aaciShip; // api_kouku.api_stage2.api_air_fire.api_idx => Ship
        this.aaciItems = opts.aaciItems; // api_kouku.api_stage2.api_air_fire.api_use_items
        this.fPlaneInit2 = opts.fPlaneInit2; // Init plane count of stage 2
        this.fPlaneNow2 = opts.fPlaneNow2; // Now  plane count of stage 2
        this.ePlaneInit2 = opts.ePlaneInit2; // ^^
        this.ePlaneNow2 = opts.ePlaneNow2; // ^^
    }
}
exports.AerialInfo = AerialInfo;
exports.AirControl = {
    Supremacy: "Air Supremacy",
    Superiority: "Air Superiority",
    Parity: "Air Parity",
    Denial: "Air Denial",
    Incapability: "Air Incapability",
};
class EngagementInfo {
    constructor(opts = {}) {
        this.engagement = opts.engagement; // api_formation[2] => Engagement
        this.fFormation = opts.fFormation; // api_formation[0] => Formation
        this.eFormation = opts.eFormation; // api_formation[1] => Formation
        this.fDetection = opts.fDetection; // api_search[0]    => Detection
        this.eDetection = opts.eDetection; // api_search[1]    => Detection
        // Night Combat
        this.fContact = opts.fContact; // api_touch_plane[0]
        this.eContact = opts.eContact; // api_touch_plane[1]
        this.fFlare = opts.fFlare; // api_flare_pos[0] => Ship
        this.eFlare = opts.eFlare; // api_flare_pos[1] => Ship
        // Weaken Mechanism (Event Map)
        this.weakened = opts.weakened; // api_boss_damaged, api_xal01, ...
        this.smokeType = opts.smokeType; // api_smoke_type
    }
}
exports.EngagementInfo = EngagementInfo;
exports.Engagement = {
    Parallel: "Parallel Engagement",
    Headon: "Head-on Engagement",
    TAdvantage: "Crossing the T (Advantage)",
    TDisadvantage: "Crossing the T (Disadvantage)",
};
exports.Formation = {
    Ahead: "Line Ahead",
    Double: "Double Line",
    Diamond: "Diamond",
    Echelon: "Echelon",
    Abreast: "Line Abreast",
    Vanguard: "Vanguard",
    CruisingAntiSub: "Cruising Formation 1 (anti-sub)",
    CruisingForward: "Cruising Formation 2 (forward)",
    CruisingDiamond: "Cruising Formation 3 (diamond)",
    CruisingBattle: "Cruising Formation 4 (battle)",
};
exports.Detection = {
    Success: "Success",
    Failure: "Failure",
    SuccessNR: "Success (not return)",
    FailureNR: "Failure (not return)",
    SuccessNP: "Success (without plane)",
    FailureNP: "Failure (without plane)",
};
class Result {
    constructor(opts = {}) {
        this.rank = opts.rank; // 'A', 'B'...
        this.mvp = opts.mvp; // [0..5, 0..5], MVP index of mainFleet & escortFleet.
        this.getShip = opts.getShip; // id of store.const.$
        this.getItem = opts.getItem; // ^^
    }
}
exports.Result = Result;
exports.Rank = {
    SS: 'SS',
    S: 'S',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
};
/**
 * NOTICE
 * Constants below are considered non-public API.
**/
// api_hougeki.api_at_type[] => ~
exports.DayAttackTypeMap = {
    0: exports.AttackType.Normal,
    1: exports.AttackType.Laser,
    2: exports.AttackType.Double,
    3: exports.AttackType.Primary_Secondary_CI,
    4: exports.AttackType.Primary_Radar_CI,
    5: exports.AttackType.Primary_AP_CI,
    6: exports.AttackType.Primary_Primary_CI,
    7: exports.AttackType.Carrier_CI,
    100: exports.AttackType.Nelson_Touch,
    101: exports.AttackType.Nagato_Punch,
    102: exports.AttackType.Mutsu_Splash,
    103: exports.AttackType.Colorado_Fire,
    105: exports.AttackType.Baguette_Charge,
    106: exports.AttackType.QE_Touch,
    300: exports.AttackType.Submarine_Special_Attack_2_3,
    301: exports.AttackType.Submarine_Special_Attack_3_4,
    302: exports.AttackType.Submarine_Special_Attack_2_4,
    400: exports.AttackType.Yamato_Attack_Triple,
    401: exports.AttackType.Yamato_Attack_Double,
    1000: exports.AttackType.Type_4_LC_Special_Attack,
};
// api_hougeki.api_sp_list => ~
exports.NightAttackTypeMap = {
    0: exports.AttackType.Normal,
    1: exports.AttackType.Double,
    2: exports.AttackType.Primary_Torpedo_CI,
    3: exports.AttackType.Torpedo_Torpedo_CI,
    4: exports.AttackType.Primary_Secondary_CI,
    5: exports.AttackType.Primary_Primary_CI,
    100: exports.AttackType.Nelson_Touch,
    101: exports.AttackType.Nagato_Punch,
    102: exports.AttackType.Mutsu_Splash,
    103: exports.AttackType.Colorado_Fire,
    104: exports.AttackType.Kongo_Class_Kaini_C_Charge,
    105: exports.AttackType.Baguette_Charge,
    106: exports.AttackType.QE_Touch,
    200: exports.AttackType.Zuiun_Night_Attack,
    300: exports.AttackType.Submarine_Special_Attack_2_3,
    301: exports.AttackType.Submarine_Special_Attack_3_4,
    302: exports.AttackType.Submarine_Special_Attack_2_4,
    400: exports.AttackType.Yamato_Attack_Triple,
    401: exports.AttackType.Yamato_Attack_Double,
    1000: exports.AttackType.Type_4_LC_Special_Attack,
};
// api_stage1.api_disp_seiku => ~
exports.AirControlMap = {
    0: exports.AirControl.Parity,
    1: exports.AirControl.Supremacy,
    2: exports.AirControl.Superiority,
    3: exports.AirControl.Denial,
    4: exports.AirControl.Incapability,
};
// api_search[] => ~
exports.DetectionMap = {
    1: exports.Detection.Success,
    2: exports.Detection.SuccessNR,
    3: exports.Detection.FailureNR,
    4: exports.Detection.Failure,
    5: exports.Detection.SuccessNP,
    6: exports.Detection.FailureNP,
};
// api_formation[0,1] => ~
exports.FormationMap = {
    1: exports.Formation.Ahead,
    2: exports.Formation.Double,
    3: exports.Formation.Diamond,
    4: exports.Formation.Echelon,
    5: exports.Formation.Abreast,
    6: exports.Formation.Vanguard,
    11: exports.Formation.CruisingAntiSub,
    12: exports.Formation.CruisingForward,
    13: exports.Formation.CruisingDiamond,
    14: exports.Formation.CruisingBattle,
};
// api_formation[2] => ~
exports.EngagementMap = {
    1: exports.Engagement.Parallel,
    2: exports.Engagement.Headon,
    3: exports.Engagement.TAdvantage,
    4: exports.Engagement.TDisadvantage,
};
// api_support_flag => ~
exports.SupportTypeMap = {
    1: exports.StageType.Aerial,
    2: exports.StageType.Shelling,
    3: exports.StageType.Torpedo,
};
// api_win_rank => ~
exports.BattleRankMap = {
    'SS': exports.Rank.SS,
    'S': exports.Rank.S,
    'A': exports.Rank.A,
    'B': exports.Rank.B,
    'C': exports.Rank.C,
    'D': exports.Rank.D,
    'E': exports.Rank.E,
};
const HalfSunkNumber = [
    0, 1, 1, 2, 2, 3, 4, 4, 5, 6, 7, 7, 8,
];
function useItem(ship) {
    if (ship.owner === exports.ShipOwner.Ours && ship.nowHP <= 0 && ship.items != null)
        for (const itemId of ship.items) {
            // 応急修理要員
            if (itemId === 42) {
                ship.nowHP = Math.floor(ship.maxHP / 5);
                return itemId;
            }
            // 応急修理女神
            if (itemId === 43) {
                ship.nowHP = ship.maxHP;
                return itemId;
            }
        }
    return null;
}
function damageShip(fromShip, toShip, damage) {
    if (toShip == null) {
        // Some legacy records contain invalid target indices.
        return { fromHP: 0, toHP: 0, item: null };
    }
    if (fromShip != null) {
        fromShip.damage += damage;
    }
    let fromHP = toShip.nowHP;
    toShip.nowHP -= damage;
    if (toShip.nowHP < 0)
        toShip.nowHP = 0;
    toShip.lostHP += damage;
    let item = useItem(toShip);
    if (item) {
        toShip.useItem = item;
    }
    let toHP = toShip.nowHP;
    // `toShip.*` is updated in place
    return { fromHP, toHP, item };
}
function preventNullObject(o) {
    // Prevent returning Object with all properties null.
    let isNull = true;
    for (const k of Object.keys(o)) {
        isNull = isNull && o[k] == null;
    }
    return isNull ? null : o;
}
function generateAerialInfo(kouku, mainFleet, escortFleet) {
    if (kouku == null)
        return null;
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const stage1 = ("api_stage1" in kouku ? kouku.api_stage1 : null) ?? null;
    const stage2 = ("api_stage2" in kouku ? kouku.api_stage2 : null) ?? null;
    const o = new AerialInfo({});
    let fPlaneLost = 0, ePlaneLost = 0;
    // Stage 1
    if (stage1 != null) {
        const contact = stage1.api_touch_plane || [-1, -1];
        if (typeof stage1.api_disp_seiku === "number") {
            o.control = exports.AirControlMap[stage1.api_disp_seiku];
        }
        o.fContact = typeof contact[0] === "number" && contact[0] > 0 ? contact[0] : null;
        o.eContact = typeof contact[1] === "number" && contact[1] > 0 ? contact[1] : null;
        const fCount = stage1.api_f_count ?? 0;
        const fLost = stage1.api_f_lostcount ?? 0;
        const eCount = stage1.api_e_count ?? 0;
        const eLost = stage1.api_e_lostcount ?? 0;
        o.fPlaneInit1 = fCount;
        o.fPlaneNow1 = fCount - fLost;
        o.ePlaneInit1 = eCount;
        o.ePlaneNow1 = eCount - eLost;
        fPlaneLost += fLost;
        ePlaneLost += eLost;
    }
    // Stage 2
    if (stage2 != null) {
        const airfire = stage2.api_air_fire;
        if (airfire != null) {
            let ship = null, idx = airfire.api_idx;
            const mainFleetRange = mainFleetShips.length;
            if (0 <= idx && idx <= mainFleetRange)
                ship = mainFleetShips[idx] ?? null;
            if (mainFleetRange <= idx)
                ship = escortFleetShips[idx - mainFleetRange] ?? null;
            o.aaciKind = airfire.api_kind;
            o.aaciShip = ship;
            o.aaciItems = airfire.api_use_items;
        }
        const fCount = stage2.api_f_count ?? 0;
        const fLost = stage2.api_f_lostcount ?? 0;
        const eCount = stage2.api_e_count ?? 0;
        const eLost = stage2.api_e_lostcount ?? 0;
        o.fPlaneInit2 = fCount;
        o.fPlaneNow2 = fCount - fLost;
        o.ePlaneInit2 = eCount;
        o.ePlaneNow2 = eCount - eLost;
        fPlaneLost += fLost;
        ePlaneLost += eLost;
    }
    // Summary
    // We assume stage2 won't exist without stage1
    if (stage1 != null) {
        const fCount = stage1.api_f_count ?? 0;
        const eCount = stage1.api_e_count ?? 0;
        o.fPlaneInit = fCount;
        o.fPlaneNow = fCount - fPlaneLost;
        o.ePlaneInit = eCount;
        o.ePlaneNow = eCount - ePlaneLost;
    }
    return preventNullObject(o);
}
function generateEngagementInfo(packet, oursFleet, emenyFleet, opts = {}) {
    if (!(packet != null))
        return null;
    const ourFleetShips = oursFleet ?? [];
    const enemyFleetShips = emenyFleet ?? [];
    opts = { ...{ engagement: false, night: false }, ...opts };
    const o = new EngagementInfo({});
    if (opts.engagement) {
        // Battle Engagement
        const { api_formation, api_search } = packet;
        if (api_formation != null) {
            const engagementKey = api_formation[2];
            const fFormationKey = api_formation[0];
            const eFormationKey = api_formation[1];
            if (typeof engagementKey === "number")
                o.engagement = exports.EngagementMap[engagementKey];
            if (typeof fFormationKey === "number")
                o.fFormation = exports.FormationMap[fFormationKey];
            if (typeof eFormationKey === "number")
                o.eFormation = exports.FormationMap[eFormationKey];
        }
        if (api_search != null) {
            const fDetectionKey = api_search[0];
            const eDetectionKey = api_search[1];
            if (typeof fDetectionKey === "number")
                o.fDetection = exports.DetectionMap[fDetectionKey];
            if (typeof eDetectionKey === "number")
                o.eDetection = exports.DetectionMap[eDetectionKey];
        }
        // Weaken mechanism
        const { api_boss_damaged, api_xal01 } = packet;
        o.weakened = [api_boss_damaged, api_xal01].find((x) => x != null);
        // Carry over smoke_type
        const { api_smoke_type } = packet;
        // old records doesn't have this key, unifying to 0.
        o.smokeType = api_smoke_type || 0;
    }
    if (opts.night) {
        // Night combat
        const { api_touch_plane, api_flare_pos } = packet;
        if (api_touch_plane != null) {
            // KANCOLLE BUG: api-touch_plane elements is string
            const plane = api_touch_plane.map(x => Number(x));
            o.fContact = plane[0] > 0 ? plane[0] : null;
            o.eContact = plane[1] > 0 ? plane[1] : null;
        }
        if (api_flare_pos != null) {
            o.fFlare = ourFleetShips[api_flare_pos[0]];
            o.eFlare = enemyFleetShips[api_flare_pos[1]];
        }
    }
    return preventNullObject(o);
}
function simulateAerialAttack(fleet, edam, ebak_flag, erai_flag, ecl_flag) {
    const targetFleetShips = fleet ?? [];
    const dam = edam ?? [];
    const bak = ebak_flag ?? [];
    const rai = erai_flag ?? [];
    const cl = ecl_flag ?? [];
    const list = [];
    for (let [i, damage] of dam.entries()) {
        if ((damage < 0) || ((bak[i] ?? 0) <= 0 && (rai[i] ?? 0) <= 0))
            continue;
        damage = Math.floor(damage);
        const toShip = targetFleetShips[i] ?? null;
        const hit = (cl[i] === 1 ? exports.HitType.Critical : (damage > 0 ? exports.HitType.Hit : exports.HitType.Miss));
        const { fromHP, toHP, item } = damageShip(null, toShip, damage);
        list.push(new Attack({
            type: exports.AttackType.Normal,
            toShip: toShip,
            damage: [damage],
            hit: [hit],
            fromHP: fromHP,
            toHP: toHP,
            useItem: item,
        }));
    }
    return list;
}
function simulateAerial(mainFleet, escortFleet, enemyFleet, enemyEscort, kouku, assault = false) {
    if (kouku == null)
        return null;
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const enemyMainShips = enemyFleet ?? [];
    const enemyEscortShips = enemyEscort ?? [];
    const carrier = kouku;
    const stage3 = carrier.api_stage3 ?? null;
    const stage3Combined = carrier.api_stage3_combined ?? null;
    let attacks = [];
    if (stage3 != null) {
        attacks = attacks.concat(simulateAerialAttack(enemyMainShips, stage3.api_edam, stage3.api_ebak_flag, stage3.api_erai_flag, stage3.api_ecl_flag));
        attacks = attacks.concat(simulateAerialAttack(mainFleetShips, stage3.api_fdam, stage3.api_fbak_flag, stage3.api_frai_flag, stage3.api_fcl_flag));
    }
    if (stage3Combined != null) {
        attacks = attacks.concat(simulateAerialAttack(enemyEscortShips, stage3Combined.api_edam, stage3Combined.api_ebak_flag, stage3Combined.api_erai_flag, stage3Combined.api_ecl_flag));
        attacks = attacks.concat(simulateAerialAttack(escortFleetShips, stage3Combined.api_fdam, stage3Combined.api_fbak_flag, stage3Combined.api_frai_flag, stage3Combined.api_fcl_flag));
    }
    const aerial = generateAerialInfo(kouku, mainFleetShips, escortFleetShips);
    return new Stage({
        type: exports.StageType.Aerial,
        subtype: assault ? exports.StageType.Assault : null,
        attacks: attacks,
        aerial: aerial,
        kouku: kouku,
    });
}
function simulateTorpedoAttack(mainFleet, escortFleet, enemyFleet, enemyEscort, eydam, erai, ecl) {
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const enemyMainShips = enemyFleet ?? [];
    const enemyEscortShips = enemyEscort ?? [];
    const dam = eydam ?? [];
    const rai = erai ?? [];
    const cl = ecl ?? [];
    const list = [];
    for (let [i, t] of rai.entries()) {
        let fromShip;
        let toShip;
        const mainFleetRange = mainFleetShips.length;
        const enemyFleetRange = enemyMainShips.length;
        if (i < 0 || t < 0)
            continue;
        if (dam[i] == null || cl[i] == null)
            continue;
        if (i < mainFleetRange) {
            fromShip = mainFleetShips[i];
        }
        else {
            fromShip = escortFleetShips[i - mainFleetRange];
        }
        if (fromShip == null)
            continue;
        if (t < enemyFleetRange) {
            toShip = enemyMainShips[t];
        }
        else {
            toShip = enemyEscortShips[t - enemyFleetRange];
        }
        if (toShip == null)
            continue;
        const damage = Math.floor(dam[i]);
        const hit = (cl[i] === 2 ? exports.HitType.Critical : (cl[i] === 1 ? exports.HitType.Hit : exports.HitType.Miss));
        let { fromHP, toHP, item } = damageShip(fromShip, toShip, damage);
        list.push(new Attack({
            type: exports.AttackType.Normal,
            fromShip: fromShip,
            toShip: toShip,
            damage: [damage],
            hit: [hit],
            fromHP: fromHP,
            toHP: toHP,
            useItem: item,
        }));
    }
    return list;
}
function simulateOpeningTorpedoAttack(mainFleet, escortFleet, enemyFleet, enemyEscort, eydamList, eraiList, eclList) {
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const enemyMainShips = enemyFleet ?? [];
    const enemyEscortShips = enemyEscort ?? [];
    const dam = eydamList ?? [];
    const rai = eraiList ?? [];
    const cl = eclList ?? [];
    const list = [];
    for (let [i, tList] of rai.entries()) {
        let fromShip;
        let toShip;
        const mainFleetRange = mainFleetShips.length;
        const enemyFleetRange = enemyMainShips.length;
        if (i < 0 || tList == null)
            continue;
        if (i < mainFleetRange)
            fromShip = mainFleetShips[i];
        else
            fromShip = escortFleetShips[i - mainFleetRange];
        if (fromShip == null)
            continue;
        for (let [j, t] of tList.entries()) {
            if (t < 0)
                continue;
            if (t < enemyFleetRange)
                toShip = enemyMainShips[t];
            else
                toShip = enemyEscortShips[t - enemyFleetRange];
            if (toShip == null)
                continue;
            const damage = Math.floor(dam[i]?.[j] ?? 0);
            const hit = (cl[i]?.[j] === 2 ? exports.HitType.Critical : (cl[i]?.[j] === 1 ? exports.HitType.Hit : exports.HitType.Miss));
            let { fromHP, toHP, item } = damageShip(fromShip, toShip, damage);
            list.push(new Attack({
                type: exports.AttackType.Normal,
                fromShip: fromShip,
                toShip: toShip,
                damage: [damage],
                hit: [hit],
                fromHP: fromHP,
                toHP: toHP,
                useItem: item,
            }));
        }
    }
    return list;
}
function simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, raigeki, subtype) {
    if (!(raigeki != null)) {
        return null;
    }
    let attacks = [];
    if (raigeki.api_frai != null)
        attacks = attacks.concat(simulateTorpedoAttack(mainFleet, escortFleet, enemyFleet, enemyEscort, (raigeki.api_fydam != null ? raigeki.api_fydam : raigeki.api_fdam), raigeki.api_frai, raigeki.api_fcl));
    if (raigeki.api_erai != null)
        attacks = attacks.concat(simulateTorpedoAttack(enemyFleet, enemyEscort, mainFleet, escortFleet, (raigeki.api_eydam != null ? raigeki.api_eydam : raigeki.api_edam), raigeki.api_erai, raigeki.api_ecl));
    return new Stage({
        type: exports.StageType.Torpedo,
        attacks: attacks,
        subtype: subtype,
    });
}
function simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, raigeki, subtype) {
    if (!(raigeki != null)) {
        return null;
    }
    if (raigeki.api_frai != null) {
        // Backward compatibility
        return simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, raigeki, subtype);
    }
    let attacks = [];
    if (raigeki.api_frai_list_items != null)
        attacks = attacks.concat(simulateOpeningTorpedoAttack(mainFleet, escortFleet, enemyFleet, enemyEscort, raigeki.api_fydam_list_items, raigeki.api_frai_list_items, raigeki.api_fcl_list_items));
    if (raigeki.api_erai_list_items != null)
        attacks = attacks.concat(simulateOpeningTorpedoAttack(enemyFleet, enemyEscort, mainFleet, escortFleet, raigeki.api_eydam_list_items, raigeki.api_erai_list_items, raigeki.api_ecl_list_items));
    return new Stage({
        type: exports.StageType.Torpedo,
        attacks: attacks,
        subtype: subtype,
    });
}
function simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, hougeki, subtype) {
    if (!(hougeki != null)) {
        return null;
    }
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const enemyMainShips = enemyFleet ?? [];
    const enemyEscortShips = enemyEscort ?? [];
    const isNight = subtype === exports.StageType.Night;
    const list = [];
    const mainFleetRange = mainFleetShips.length;
    const enemyFleetRange = enemyMainShips.length;
    for (let [i, attacker] of (hougeki.api_at_list || []).entries()) {
        if (attacker === -1)
            continue;
        const spList = hougeki.api_sp_list;
        const atType = hougeki.api_at_type;
        const spKey = spList?.[i] ?? 0;
        const atKey = atType?.[i] ?? 0;
        let attackType = isNight
            ? (exports.NightAttackTypeMap[spKey] ?? exports.AttackType.Normal)
            : (exports.DayAttackTypeMap[atKey] ?? exports.AttackType.Normal);
        let at = attacker;
        if (!exports.MultiTargetAttackType.has(attackType)) {
            let df = hougeki.api_df_list[i][0]; // Defender
            let fromEnemy;
            if (hougeki.api_at_eflag != null) {
                fromEnemy = hougeki.api_at_eflag[i] === 1;
            }
            else {
                fromEnemy = df < mainFleetRange;
                if (at >= mainFleetRange)
                    at -= mainFleetRange;
                if (df >= mainFleetRange)
                    df -= mainFleetRange;
            }
            let fromShip;
            let toShip;
            if (fromEnemy) {
                fromShip = at < enemyFleetRange ? enemyMainShips[at] : enemyEscortShips[at - enemyFleetRange];
                toShip = df < mainFleetRange ? mainFleetShips[df] : escortFleetShips[df - mainFleetRange];
            }
            else {
                fromShip = at < mainFleetRange ? mainFleetShips[at] : escortFleetShips[at - mainFleetRange];
                toShip = df < enemyFleetRange ? enemyMainShips[df] : enemyEscortShips[df - enemyFleetRange];
            }
            let damage = [];
            let damageTotal = 0;
            for (let dmg of hougeki.api_damage[i]) {
                if (dmg < 0)
                    dmg = 0;
                dmg = Math.floor(dmg);
                damage.push(dmg);
                damageTotal += dmg;
            }
            let hit = [];
            for (const cl of hougeki.api_cl_list[i])
                hit.push(cl === 2 ? exports.HitType.Critical : (cl === 1 ? exports.HitType.Hit : exports.HitType.Miss));
            let { fromHP, toHP, item } = damageShip(fromShip, toShip, damageTotal);
            list.push(new Attack({
                type: attackType,
                fromShip: fromShip,
                toShip: toShip,
                damage: damage,
                hit: hit,
                fromHP: fromHP,
                toHP: toHP,
                useItem: item,
            }));
        }
        else {
            const order = exports.MultiTargetAttackOrder[attackType] || [];
            for (let j = 0; j < hougeki.api_df_list[i].length; j++) {
                let df = hougeki.api_df_list[i][j]; // Defender
                let fromEnemy;
                let at = attacker + (order[j] || 0); // Attacker
                // Tanaka bug: in combined night battle the sp attack could have wrong attacker index
                if (isNight && escortFleet && escortFleet.length && at < mainFleetRange) {
                    at += mainFleetRange;
                }
                if (hougeki.api_at_eflag != null) {
                    fromEnemy = hougeki.api_at_eflag[i] === 1;
                }
                else {
                    fromEnemy = df < mainFleetRange;
                    if (at >= mainFleetRange)
                        at -= mainFleetRange;
                    if (df >= mainFleetRange)
                        df -= mainFleetRange;
                }
                let fromShip;
                let toShip;
                if (fromEnemy) {
                    fromShip = at < enemyFleetRange ? enemyMainShips[at] : enemyEscortShips[at - enemyFleetRange];
                    toShip = df < mainFleetRange ? mainFleetShips[df] : escortFleetShips[df - mainFleetRange];
                }
                else {
                    fromShip = at < mainFleetRange ? mainFleetShips[at] : escortFleetShips[at - mainFleetRange];
                    toShip = df < enemyFleetRange ? enemyMainShips[df] : enemyEscortShips[df - enemyFleetRange];
                }
                let damage = [];
                let dmg = hougeki.api_damage[i][j];
                if (dmg < 0)
                    dmg = 0;
                dmg = Math.floor(dmg);
                damage.push(dmg);
                let hit = [];
                let cl = hougeki.api_cl_list[i][j];
                hit.push(cl === 2 ? exports.HitType.Critical : (cl === 1 ? exports.HitType.Hit : exports.HitType.Miss));
                let { fromHP, toHP, item } = damageShip(fromShip, toShip, dmg);
                list.push(new Attack({
                    type: attackType,
                    fromShip: fromShip,
                    toShip: toShip,
                    damage: damage,
                    hit: hit,
                    fromHP: fromHP,
                    toHP: toHP,
                    useItem: item,
                }));
            }
        }
    }
    return new Stage({
        type: exports.StageType.Shelling,
        attacks: list,
        subtype: subtype,
    });
}
function simulateNight(fleetType, mainFleet, escortFleet, enemyType, enemyFleet, enemyEscort, hougeki, packet) {
    const stage = simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, hougeki, exports.StageType.Night);
    if (stage) {
        let _oursFleet = fleetType === 0 ? (mainFleet || []) : (escortFleet || []);
        let _enemyFleet = enemyType === 0 ? (enemyFleet || []) : (enemyEscort || []);
        if (packet.api_active_deck != null) {
            if (packet.api_active_deck[0] === 1) {
                _oursFleet = mainFleet || [];
            }
            if (packet.api_active_deck[0] === 2) {
                _oursFleet = escortFleet || [];
            }
            if (packet.api_active_deck[1] === 1) {
                _enemyFleet = enemyFleet || [];
            }
            if (packet.api_active_deck[1] === 2) {
                _enemyFleet = enemyEscort || [];
            }
        }
        stage.engagement = generateEngagementInfo(packet, _oursFleet, _enemyFleet, { night: true });
    }
    return stage;
}
function simulateSupport(enemyFleet, enemyEscort, support, flag) {
    if (!(support != null && flag != null))
        return null;
    const enemyMainShips = enemyFleet ?? [];
    const enemyEscortShips = enemyEscort ?? [];
    if (flag === 1 || flag === 4) {
        const kouku = support.api_support_airatack;
        if (kouku == null || typeof kouku !== "object")
            return null;
        const st3 = kouku.api_stage3 ?? null;
        if (st3 == null)
            return null;
        const supportTargetShips = [...enemyMainShips, ...enemyEscortShips];
        const attacks = simulateAerialAttack(supportTargetShips, st3.api_edam, st3.api_ebak_flag, st3.api_erai_flag, st3.api_ecl_flag);
        const aerial = generateAerialInfo(kouku, null, null);
        return new Stage({
            type: exports.StageType.Support,
            subtype: exports.SupportTypeMap[flag],
            attacks: attacks,
            aerial: aerial,
            kouku: kouku,
        });
    }
    if (flag === 2 || flag === 3) {
        const hourai = support.api_support_hourai;
        if (hourai == null || typeof hourai !== "object")
            return null;
        const api_damage = hourai.api_damage ?? [];
        const api_cl_list = hourai.api_cl_list ?? [];
        const attacks = [];
        const enemyFleetRange = enemyMainShips.length;
        for (let [i, damage] of api_damage.entries()) {
            let toShip;
            if (0 <= i && i < enemyFleetRange)
                toShip = enemyMainShips[i];
            if (enemyFleetRange <= i) // TANAKA: api_damage.length = 7 with 6 ships
                toShip = enemyEscortShips[i - enemyFleetRange];
            if (toShip == null)
                continue;
            damage = Math.floor(damage);
            const cl = api_cl_list[i];
            const hit = (cl === 2 ? exports.HitType.Critical : (cl === 1 ? exports.HitType.Hit : exports.HitType.Miss));
            // No showing Miss attack on support stage.
            if (hit === exports.HitType.Miss)
                continue;
            const { fromHP, toHP, item } = damageShip(null, toShip, damage);
            attacks.push(new Attack({
                type: exports.AttackType.Normal,
                toShip: toShip,
                damage: [damage],
                hit: [hit],
                fromHP: fromHP,
                toHP: toHP,
                useItem: item,
            }));
        }
        return new Stage({
            type: exports.StageType.Support,
            subtype: exports.SupportTypeMap[flag],
            attacks: attacks,
        });
    }
    return null;
}
function simulateLandBase(enemyFleet, enemyEscort, kouku, assault = false) {
    let stage = simulateAerial(null, null, enemyFleet, enemyEscort, kouku);
    if (stage != null) {
        stage.type = exports.StageType.LandBase;
        stage.subtype = assault ? exports.StageType.Assault : null;
    }
    return stage;
}
function simulateBattleRank(mainFleet, escortFleet, enemyFleet, enemyEscort) {
    // https://github.com/andanteyk/ElectronicObserver/blob/master/ElectronicObserver/Other/Information/kcmemo.md#%E6%88%A6%E9%97%98%E5%8B%9D%E5%88%A9%E5%88%A4%E5%AE%9A
    function calStatus(fleet) {
        let shipNum = 0, sunkNum = 0, totalHP = 0, lostHP = 0;
        let flagshipSunk = false, flagshipCritical = false;
        for (const ship of fleet) {
            if (ship == null)
                continue;
            // Ships whose HP is hidden by the game ('N/A') take no part in the
            // rank calculation, so sinking every other enemy still counts as S.
            if (ship.hpUnknown)
                continue;
            let { initHP, nowHP, maxHP } = ship;
            if (nowHP < 0)
                nowHP = 0;
            shipNum += 1;
            sunkNum += (nowHP <= 0) ? 1 : 0;
            totalHP += initHP;
            lostHP += (initHP - nowHP);
            if (ship.pos === 0) {
                flagshipSunk = (nowHP <= 0);
                flagshipCritical = (nowHP * 4 <= maxHP);
            }
        }
        return {
            num: shipNum,
            sunk: sunkNum,
            rate: totalHP > 0 ? Math.floor(lostHP / totalHP * 100) : 0,
            lostHP, flagshipSunk, flagshipCritical,
        };
    }
    const ours = calStatus([...(mainFleet ?? []), ...(escortFleet ?? [])]);
    const enemy = calStatus([...(enemyFleet ?? []), ...(enemyEscort ?? [])]);
    if (ours.sunk === 0) {
        if (enemy.num > 0 && enemy.sunk === enemy.num) {
            if (ours.lostHP <= 0)
                return exports.Rank.SS;
            else
                return exports.Rank.S;
        }
        if (enemy.num > 1 && enemy.sunk >= HalfSunkNumber[enemy.num]) {
            return exports.Rank.A;
        }
    }
    if (enemy.flagshipSunk && ours.sunk < enemy.sunk) {
        return exports.Rank.B;
    }
    if (ours.num === 1 && ours.flagshipCritical) {
        return exports.Rank.D;
    }
    if (2 * enemy.rate > 5 * ours.rate) {
        return exports.Rank.B;
    }
    if (10 * enemy.rate > 9 * ours.rate) {
        return exports.Rank.C;
    }
    if (ours.sunk > 0 && (ours.num - ours.sunk) === 1) {
        return exports.Rank.E;
    }
    return exports.Rank.D;
}
function simulateAirRaidBattleRank(mainFleet, escortFleet) {
    // https://github.com/andanteyk/ElectronicObserver/blob/master/ElectronicObserver/Other/Information/kcmemo.md#%E9%95%B7%E8%B7%9D%E9%9B%A2%E7%A9%BA%E8%A5%B2%E6%88%A6%E3%81%A7%E3%81%AE%E5%8B%9D%E5%88%A9%E5%88%A4%E5%AE%9A
    const mainFleetShips = mainFleet ?? [];
    const escortFleetShips = escortFleet ?? [];
    const initHPSum = [...mainFleetShips, ...escortFleetShips].reduce((x, s) => x + (s ? s.initHP : 0), 0);
    const nowHPSum = [...mainFleetShips, ...escortFleetShips].reduce((x, s) => x + (s ? s.nowHP : 0), 0);
    let rate = (initHPSum - nowHPSum) / initHPSum * 100;
    if (rate <= 0)
        return exports.Rank.SS;
    if (rate < 10)
        return exports.Rank.A;
    if (rate < 20)
        return exports.Rank.B;
    if (rate < 50)
        return exports.Rank.C;
    if (rate < 80)
        return exports.Rank.D;
    // else
    return exports.Rank.E;
}
function simulateFleetMVP(fleet) {
    const fleetShips = fleet ?? [];
    let m = -1, mvp = null;
    for (const [i, ship] of fleetShips.entries()) {
        if (ship == null)
            continue;
        if (mvp == null || ship.damage > mvp.damage) {
            m = i;
            mvp = ship;
        }
    }
    return m;
}
function simulateFleetNightMVP(stages) {
    const ss = stages ?? [];
    // Damage sum: Only escort fleet
    let sum = Array(6).fill(0);
    for (const stage of ss) {
        if (!(stage != null && stage.attacks != null))
            continue;
        if (!(stage.type === exports.StageType.Shelling && stage.subtype === exports.StageType.Night))
            continue;
        for (const attack of stage.attacks) {
            const { fromShip: ship, damage } = attack;
            if (ship == null || ship.owner !== exports.ShipOwner.Ours)
                continue;
            const { pos } = ship;
            if (6 <= pos && pos <= 11)
                sum[pos - 7] += (damage ?? []).reduce((x, y) => x + y, 0);
            else
                console.warn("Non-escort fleet ship attack in night stage", ship, attack);
        }
    }
    let m = 0; // MVP index
    for (const [i, damage] of sum.entries()) {
        if (damage > sum[m]) {
            m = i;
        }
    }
    return m;
}
function getEngagementStage(packet) {
    // This function is usable for day combat only.
    const engagement = generateEngagementInfo(packet, [], [], { engagement: true });
    return engagement == null ? null : new Stage({
        type: exports.StageType.Engagement,
        engagement: engagement,
    });
}
class Simulator2 {
    constructor(fleet, opts = {}) {
        // When no using poi API:
        //   enemyShip.raw == null
        this.usePoiAPI = opts.usePoiAPI;
        this.fleetType = fleet.type || 0;
        this.mainFleet = this._initFleet(fleet.main, 0);
        this.escortFleet = this._initFleet(fleet.escort, 6);
        this.supportFleet = this._initFleet(fleet.support);
        this.landBaseAirCorps = fleet.LBAC;
        this.enemyFleet = null; // Assign at first packet
        this.enemyEscort = null; // ^
        this.friendFleet = null; // NPC Friend fleet support
        this.enemyType = 0;
        // Stage
        this.stages = [];
        this._result = null;
        this._isAirRaid = false;
        this._isEngaged = false;
        this._isNightOnlyMVP = false;
    }
    static auto(battle, opts) {
        if (battle == null)
            return;
        if (battle.fleet == null || battle.packet == null)
            return;
        let s = new Simulator2(battle.fleet, opts);
        for (const packet of battle.packet)
            s.simulate(packet);
        return s;
    }
    _initFleet(rawFleet, intl = 0) {
        if (!(rawFleet != null))
            return;
        const fleet = [];
        for (let [i, rawShip] of rawFleet.entries()) {
            if (rawShip != null && isRawFleetShip(rawShip)) {
                const slots = [...(rawShip.poi_slot ?? []), ...(rawShip.poi_slot_ex ? [rawShip.poi_slot_ex] : [])];
                let baseParam;
                let finalParam;
                if (this.usePoiAPI) {
                    const kyouka = rawShip.api_kyouka;
                    const $ship = getShipDb()[rawShip.api_ship_id];
                    if (typeof $ship !== "undefined") {
                        baseParam = param4($ship.api_houg[0] + (kyouka[0] ?? 0), $ship.api_raig[0] + (kyouka[1] ?? 0), $ship.api_tyku[0] + (kyouka[2] ?? 0), $ship.api_souk[0] + (kyouka[3] ?? 0));
                    }
                    finalParam = param4(rawShip.api_karyoku[0], rawShip.api_raisou[0], rawShip.api_taiku[0], rawShip.api_soukou[0]);
                }
                fleet.push(new Ship({
                    id: rawShip.api_ship_id,
                    owner: exports.ShipOwner.Ours,
                    pos: intl + i + 1,
                    maxHP: rawShip.api_maxhp,
                    nowHP: rawShip.api_nowhp,
                    items: slots.map(slot => slot != null ? slot.api_slotitem_id : null),
                    baseParam: baseParam,
                    finalParam: finalParam,
                    raw: rawShip,
                }));
            }
            else {
                fleet.push(null);
            }
        }
        return fleet;
    }
    _initEnemy(intl = 0, api_ship_ke, api_eSlot, api_e_maxhps, api_e_nowhps, api_ship_lv, api_param = [], owner = exports.ShipOwner.Enemy) {
        if (!(api_ship_ke != null))
            return;
        let fleet = [];
        const range = [...new Array(api_ship_ke.length).keys()];
        for (const i of range) {
            let id = api_ship_ke[i];
            let slots = (api_eSlot && api_eSlot[i]) || [];
            let ship = null;
            let raw;
            let baseParam;
            let finalParam;
            if (typeof id === "number" && id > 0) {
                if (api_ship_lv == null)
                    api_ship_lv = [];
                if (api_e_maxhps == null)
                    api_e_maxhps = [];
                if (api_e_nowhps == null)
                    api_e_nowhps = [];
                if (this.usePoiAPI) {
                    raw = {
                        api_ship_id: id,
                        api_lv: api_ship_lv[i],
                        poi_slot: slots.map(id => getSlotItemDb()[id]),
                    };
                    baseParam = toParam4(api_param[i]);
                    finalParam = slots.reduce((bonus, id) => {
                        const item = getSlotItemDb()[id] || {};
                        return [
                            bonus[0] + (item.api_houg || 0),
                            bonus[1] + (item.api_raig || 0),
                            bonus[2] + (item.api_tyku || 0),
                            bonus[3] + (item.api_souk || 0),
                        ];
                    }, baseParam);
                }
                // The game may hide an enemy's HP, sending a placeholder ('N/A') in
                // place of the number. Keep the raw value so consumers can still
                // display it, and flag the ship so it can be ignored where HP matters.
                const rawMaxHP = api_e_maxhps[i];
                const rawNowHP = api_e_nowhps[i];
                const hpUnknown = typeof rawMaxHP !== "number" || typeof rawNowHP !== "number";
                ship = new Ship({
                    id: id,
                    owner: owner,
                    pos: intl + i,
                    maxHP: rawMaxHP,
                    nowHP: rawNowHP,
                    hpUnknown: hpUnknown,
                    items: [], // We dont care
                    baseParam: baseParam,
                    finalParam: finalParam,
                    raw: raw,
                });
            }
            fleet.push(ship);
        }
        return fleet;
    }
    simulate(packet) {
        if (packet == null)
            return;
        if (!isBattlePacket(packet))
            return;
        const path = packet.poi_path;
        this.prepare(packet, path);
        this.assert(packet, path);
        // Engagement
        if (this._isEngaged === false) {
            this._isEngaged = true;
            this.stages.push(getEngagementStage(packet));
        }
        // Day Battle
        if (['/kcsapi/api_req_practice/battle',
            '/kcsapi/api_req_sortie/battle',
            '/kcsapi/api_req_sortie/airbattle',
            '/kcsapi/api_req_sortie/ld_airbattle',
            '/kcsapi/api_req_sortie/ld_shooting',
            '/kcsapi/api_req_combined_battle/battle',
            '/kcsapi/api_req_combined_battle/battle_water',
            '/kcsapi/api_req_combined_battle/airbattle',
            '/kcsapi/api_req_combined_battle/ld_airbattle',
            '/kcsapi/api_req_combined_battle/ld_shooting',
            '/kcsapi/api_req_combined_battle/ec_battle',
            '/kcsapi/api_req_combined_battle/each_battle',
            '/kcsapi/api_req_combined_battle/each_battle_water',
        ].includes(path)) {
            this.prcsDay(packet, path);
        }
        // Night Battle
        if (['/kcsapi/api_req_practice/midnight_battle',
            '/kcsapi/api_req_battle_midnight/battle',
            '/kcsapi/api_req_battle_midnight/sp_midnight',
            '/kcsapi/api_req_combined_battle/midnight_battle',
            '/kcsapi/api_req_combined_battle/sp_midnight',
            '/kcsapi/api_req_combined_battle/ec_midnight_battle',
            '!COMPAT/midnight_battle',
        ].includes(path)) {
            this.prcsNight(packet, path);
        }
        // Night to Day
        if (['/kcsapi/api_req_combined_battle/ec_night_to_day'].includes(path)) {
            this.prcsNight(packet, path);
            this.prcsDay(packet, path);
        }
        // Battle Result
        if (['/kcsapi/api_req_practice/battle_result',
            '/kcsapi/api_req_sortie/battleresult',
            '/kcsapi/api_req_combined_battle/battleresult',
        ].includes(path)) {
            this.prcsResult(packet, path);
        }
    }
    prepare(packet, path) {
        const { fleetType, enemyFleet } = this;
        if (enemyFleet == null) {
            // Older records may not have api_e_* hp arrays; fall back to api_(max|now)hps.
            // The arrays include both fleets with 1-based indices (api_nowhps[1..]).
            const eMaxHps = packet.api_e_maxhps || packet.api_maxhps;
            const eNowHps = packet.api_e_nowhps || packet.api_nowhps;
            this.enemyFleet = this._initEnemy(0, packet.api_ship_ke, packet.api_eSlot, eMaxHps, eNowHps, packet.api_ship_lv, packet.api_eParam) ?? null;
            if (packet.api_ship_ke) {
                const eMaxHpsCombined = packet.api_e_maxhps_combined || packet.api_maxhps_combined;
                const eNowHpsCombined = packet.api_e_nowhps_combined || packet.api_nowhps_combined;
                this.enemyEscort = this._initEnemy(packet.api_ship_ke.length, packet.api_ship_ke_combined, packet.api_eSlot_combined, eMaxHpsCombined, eNowHpsCombined, packet.api_ship_lv_combined, packet.api_eParam_combined) ?? null;
            }
        }
        // HACK: Only enemy carrier task force now.
        this.enemyType = (path.includes('ec_') || path.includes('each_')) ? 1 : 0;
        if (packet.api_friendly_info != null) {
            const info = packet.api_friendly_info;
            this.friendFleet = this._initEnemy(0, info.api_ship_id, info.api_Slot, info.api_maxhps, info.api_nowhps, info.api_ship_lv, info.api_Param, exports.ShipOwner.Friend) ?? null;
        }
        // MVP rule is special for combined fleet. It may be a kancolle bug.
        if (['/kcsapi/api_req_combined_battle/midnight_battle',
        ].includes(path)) {
            if (fleetType === 1 || fleetType === 2 || fleetType === 3) {
                this._isNightOnlyMVP = true;
            }
        }
        // Rank rule is special for ld_airbattle and ld_shooting (considered as raid).
        // FIXME: rename _isAirRaid to a more general name
        if ([
            '/kcsapi/api_req_sortie/ld_airbattle',
            '/kcsapi/api_req_sortie/ld_shooting',
            '/kcsapi/api_req_combined_battle/ld_airbattle',
            '/kcsapi/api_req_combined_battle/ld_shooting',
        ].includes(path)) {
            this._isAirRaid = true;
        }
    }
    assert(_packet, path) {
        const { fleetType } = this;
        /** Assert fleet.type with API Path **/
        // Normal Fleet
        if (['/kcsapi/api_req_practice/battle',
            '/kcsapi/api_req_sortie/battle',
            '/kcsapi/api_req_sortie/airbattle',
            '/kcsapi/api_req_sortie/ld_airbattle',
            '/kcsapi/api_req_sortie/ld_shooting',
            '/kcsapi/api_req_combined_battle/ec_battle',
            '/kcsapi/api_req_practice/midnight_battle',
            '/kcsapi/api_req_battle_midnight/battle',
            '/kcsapi/api_req_battle_midnight/sp_midnight',
        ].includes(path)) {
            if (!(fleetType === 0)) {
                console.warn(`${path} expect fleet.type=0, but got ${fleetType}.`);
                this.fleetType = 0;
            }
        }
        // Carrier Task Force & Transport Escort
        if (['/kcsapi/api_req_combined_battle/battle',
            '/kcsapi/api_req_combined_battle/each_battle',
        ].includes(path)) {
            if (!(fleetType === 1 || fleetType === 3)) {
                console.warn(`${path} expect fleet.type=1,3, but got ${fleetType}.`);
                // HACK: Currently CTF & TE act the same
                this.fleetType = 1;
            }
        }
        // Surface Task Force
        if (['/kcsapi/api_req_combined_battle/battle_water',
            '/kcsapi/api_req_combined_battle/each_battle_water',
        ].includes(path)) {
            if (!(fleetType === 2)) {
                console.warn(`${path} expect fleet.type=2, but got ${fleetType}.`);
                this.fleetType = 2;
            }
        }
        // Combined Fleet
        if (['/kcsapi/api_req_combined_battle/airbattle',
            '/kcsapi/api_req_combined_battle/ld_airbattle',
            '/kcsapi/api_req_combined_battle/ld_shooting',
            '/kcsapi/api_req_combined_battle/midnight_battle',
            '/kcsapi/api_req_combined_battle/sp_midnight',
        ].includes(path)) {
            if (!(fleetType === 1 || fleetType === 2 || fleetType === 3)) {
                console.warn(`${path} expect fleet.type=1,2,3, but got ${fleetType}.`);
                // We can't detemine fleet.type
            }
        }
        // Any
        if (['/kcsapi/api_req_combined_battle/ec_midnight_battle',
        ].includes(path)) {
            if (!(fleetType === 0 || fleetType === 1 || fleetType === 2 || fleetType === 3)) {
                console.warn(`${path} expect fleet.type=0,1,2,3, but got ${fleetType}.`);
                // We can't detemine fleet.type
            }
        }
    }
    prcsDay(packet, path) {
        const { fleetType, mainFleet, escortFleet, enemyType, enemyFleet, enemyEscort, friendFleet } = this;
        const { stages } = this;
        // Land base air attack (assault)
        stages.push(simulateLandBase(enemyFleet, enemyEscort, packet.api_air_base_injection, true));
        // Aerial Combat (assault)
        stages.push(simulateAerial(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_injection_kouku, true));
        // Land base air attack
        for (const api_kouku of packet.api_air_base_attack || [])
            stages.push(simulateLandBase(enemyFleet, enemyEscort, api_kouku));
        // Arrial Combat (friendly)
        stages.push(simulateAerial(friendFleet, null, enemyFleet, enemyEscort, packet.api_friendly_kouku));
        // Aerial Combat
        stages.push(simulateAerial(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_kouku));
        // Aerial Combat 2nd
        stages.push(simulateAerial(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_kouku2));
        // Expedition Support Fire
        stages.push(simulateSupport(enemyFleet, enemyEscort, packet.api_support_info, packet.api_support_flag));
        // Normal Fleet
        if (fleetType === 0) {
            if (enemyType === 0) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Main), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1));
                // Shelling (Main), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
            }
            if (enemyType === 1) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Escort)
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
                // Shelling (Any), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2));
                // Shelling (Any), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki3));
            }
        }
        // Surface Task Force, 水上打撃部隊
        if (fleetType === 2) {
            if (enemyType === 0) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Main), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1, exports.StageType.Main));
                // Shelling (Main), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2, exports.StageType.Main));
                // Shelling (Escort)
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki3, exports.StageType.Escort));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
            }
            if (enemyType === 1) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Main), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1, exports.StageType.Main));
                // Shelling (Main), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2, exports.StageType.Main));
                // Shelling (Escort)
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki3, exports.StageType.Escort));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
            }
        }
        // Carrier Task Force, 空母機動部隊
        // Transport Escort, 輸送護衛部隊
        if (fleetType === 1 || fleetType === 3) {
            if (enemyType === 0) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Escort)
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1, exports.StageType.Escort));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
                // Shelling (Main), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2, exports.StageType.Main));
                // Shelling (Main), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki3, exports.StageType.Main));
            }
            if (enemyType === 1) {
                // Opening Anti-Sub
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_taisen, exports.StageType.Opening));
                // Opening Torpedo Salvo
                stages.push(simulateOpeningTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_opening_atack, exports.StageType.Opening));
                // Shelling (Main), 1st
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki1, exports.StageType.Main));
                // Shelling (Escort)
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki2, exports.StageType.Escort));
                // Closing Torpedo Salvo
                stages.push(simulateTorpedo(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_raigeki));
                // Shelling (Main), 2nd
                stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_hougeki3, exports.StageType.Main));
            }
        }
    }
    prcsNight(packet, path) {
        const { stages, fleetType, mainFleet, escortFleet, friendFleet, enemyType, enemyFleet, enemyEscort } = this;
        // Night to Day Support
        stages.push(simulateSupport(enemyFleet, enemyEscort, packet.api_n_support_info, packet.api_n_support_flag));
        // Night to Day Combat
        stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_n_hougeki1, exports.StageType.Night));
        stages.push(simulateShelling(mainFleet, escortFleet, enemyFleet, enemyEscort, packet.api_n_hougeki2, exports.StageType.Night));
        // NPC Friend Support
        stages.push(simulateShelling(friendFleet, null, enemyFleet, enemyEscort, (packet.api_friendly_battle || {}).api_hougeki, exports.StageType.Night));
        // Night Combat
        stages.push(simulateNight(fleetType, mainFleet, escortFleet, enemyType, enemyFleet, enemyEscort, packet.api_hougeki, packet));
    }
    prcsResult(packet, _path) {
        const { mainFleet, escortFleet } = this;
        const rankKey = packet.api_win_rank ?? 'D';
        let rank = exports.BattleRankMap[rankKey];
        if (rank === exports.Rank.S) {
            const mainFleetShips = mainFleet ?? [];
            const escortFleetShips = escortFleet ?? [];
            const initHPSum = [...mainFleetShips, ...escortFleetShips].reduce((x, s) => x + (s ? s.initHP : 0), 0);
            const nowHPSum = [...mainFleetShips, ...escortFleetShips].reduce((x, s) => x + (s ? s.nowHP : 0), 0);
            if (nowHPSum >= initHPSum)
                rank = exports.Rank.SS;
        }
        this._result = new Result({
            rank: rank,
            mvp: [(packet.api_mvp || 0) - 1, (packet.api_mvp_combined || 0) - 1],
            getShip: (packet.api_get_ship || {}).api_ship_id,
            getItem: (packet.api_get_useitem || {}).api_useitem_id,
        });
    }
    get result() {
        if (this._result != null)
            return this._result;
        // Simulate battle result
        const rank = this._isAirRaid
            ? simulateAirRaidBattleRank(this.mainFleet, this.escortFleet)
            : simulateBattleRank(this.mainFleet, this.escortFleet, this.enemyFleet, this.enemyEscort);
        const mvp = this._isNightOnlyMVP
            ? [0, simulateFleetNightMVP(this.stages)]
            : [simulateFleetMVP(this.mainFleet), simulateFleetMVP(this.escortFleet)];
        return new Result({ rank, mvp });
    }
}
exports.default = Simulator2;
//# sourceMappingURL=simulator.js.map